module.exports = __webpack_public_path__ + "static/img/banner_bg3.716887e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner_bg3.jpg
// module id = kCW2
// module chunks = 9